import React from "react";
import { Wrapper, Content } from "./style";

// import config from "config.json";

// import logo from "assets/img/logo_white.png";
import bg from "assets/img/bg.jpg";

//Components
import Background from "components/Background";

//3rd party
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import Menu from "components/Menu";
import { useState, useEffect } from "react";
// import docs from "../../assets/docs.json";

export default function Noticia(props) {
  const { slug } = props;
  const [localState, setLocalState] = useState({ isOpen: false });
  const [noticia, setNoticia] = useState("");

  useEffect(() => {
    const tgt = document.getElementsByClassName("_menu_ref")[0];

    if (!tgt) {
      return;
    }

    const toggleMenu = () => {
      // //console.log("clicou");
      setLocalState({ ...localState, isOpen: !localState.isOpen });
    };

    tgt.addEventListener("click", toggleMenu);
    return () => {
      tgt.removeEventListener("click", toggleMenu);
    };
  }, [localState.isOpen]);

  useEffect(() => {
    /*  anime
        .timeline({
          easing: `easeInOutQuad`,
          // delay: (el, i) => i * 100
        })
        .add({
          targets: [".rowUp.first"],
          translateY: [50, 0],
          scale: [1.1, 1],
          opacity: [0, 1],
        })
        .add(
          {
            targets: [".rowUp:not(.first)"],
            translateY: [50, 0],
            scale: [1.1, 1],
            opacity: [0, 1],
          },
          `-=500`
        )
        .play(); */
    const fetchNoticia = async () => {
      if (!slug) return null;
      try {
        const response = await fetch(`/esg_noticias/${slug}.html`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.text();
        console.log("Noticias data:", data);
        setNoticia(data);
      } catch (error) {
        console.error("Error fetching noticias:", error);
      }
    };
    fetchNoticia();
  }, []);
  if (!props["slug"]) return null;

  return (
    <>
      <Background image={bg}>
        <Wrapper>
          <Container fluid>
            <Row
              style={{
                top: 0,
                position: `fixed`,
                width: `100%`,
                zIndex: !!localState.isOpen ? 99999 : 10,
              }}
            >
              <Menu></Menu>
            </Row>
            <div id="conteudo">
              <Row className="text-center mt-0">
                <Col>
                  <Content.subtitle>
                    <a href="/esg/noticias" className="link">Voltar para Noticias sobre sustentabilidade</a>
                  </Content.subtitle>
                </Col>
              </Row>
              <Row className="mt-0 mt-md-5">
                <Col>
                  <Content.paragraph as={"div"} className="noticia">
                    <div dangerouslySetInnerHTML={{ __html: noticia }} />
                  </Content.paragraph>
                </Col>
              </Row>
              <Row className="text-center mt-0 mt-md-5">
                <Col>
                  <Content.subtitle>
                    <a href="/esg/noticias" className="link">Voltar para Noticias sobre sustentabilidade</a>
                  </Content.subtitle>
                </Col>
              </Row>
            </div>
          </Container>
        </Wrapper>
      </Background>
    </>
  );
}
